import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, QueryIntentProjectArgs } from "types/generated";

export const GET_INTENT_PROJECT_CONFIG: TypedDocumentNode<
  { intentProject: Pick<IntentProject, "id" | "configElements"> },
  QueryIntentProjectArgs
> = gql`
  query GetIntentProjectConfig($id: ID!) {
    intentProject(id: $id) {
      id
      configElements {
        checksum
        createdAt
        description
        fileMode
        id
        runtime
        type
        value
        writeOnly
      }
    }
  }
`;
